export enum ExamCourseMaster {
  EDIT = 'Edit',
  VIEW = 'View',
  ADD = 'Add',
}

export enum AddEditCourseMasterType {
  UPDATE = 'UPDATE',
  CREATE = 'CREATE',
}
